// Shared constants + formatters for the Client Portal sub-components.

export const TOKEN_KEY = "reachvel_client_token";
export const FIN_KEY   = "reachvel_client_finance";

// Colorful pill tones for client status — each status has its own distinct hue.
export const STATUS_TONE = {
  "Planning":                       "bg-cyan-100 text-cyan-800 border-cyan-300",
  "Requirement Gathering":          "bg-blue-100 text-blue-800 border-blue-300",
  "Design In Progress":             "bg-fuchsia-100 text-fuchsia-800 border-fuchsia-300",
  "Development In Progress":        "bg-indigo-100 text-indigo-800 border-indigo-300",
  "Testing In Progress":            "bg-violet-100 text-violet-800 border-violet-300",
  "Client Review (V1 Delivered)":   "bg-amber-100 text-amber-800 border-amber-300",
  "Revisions In Progress":          "bg-orange-100 text-orange-800 border-orange-300",
  "Live":                           "bg-green-100 text-green-800 border-green-400",
  "Support & Maintenance":          "bg-teal-100 text-teal-800 border-teal-300",
  "Completed":                      "bg-emerald-100 text-emerald-800 border-emerald-400",
  "On Hold":                        "bg-yellow-100 text-yellow-800 border-yellow-400",
  "Cancelled":                      "bg-rose-100 text-rose-800 border-rose-300",
  // Legacy aliases (kept so historical project rows still render in color)
  "V1 Delivered":                   "bg-amber-100 text-amber-800 border-amber-300",
  "Development In-Progress":        "bg-indigo-100 text-indigo-800 border-indigo-300",
  "New Project":                    "bg-cyan-100 text-cyan-800 border-cyan-300",
  "Awaiting Confirmation":          "bg-orange-100 text-orange-800 border-orange-300",
};

export const WEBSITE_TONE = {
  "Planning":           "bg-cyan-100 text-cyan-800 border-cyan-300",
  "Development":        "bg-sky-100 text-sky-800 border-sky-300",
  "Testing":            "bg-violet-100 text-violet-800 border-violet-300",
  "Live":               "bg-green-100 text-green-800 border-green-400",
  "Maintenance":        "bg-amber-100 text-amber-800 border-amber-400",
  "Maintainence":       "bg-amber-100 text-amber-800 border-amber-400",
  "Hold":               "bg-yellow-100 text-yellow-800 border-yellow-400",
  "Completed":          "bg-emerald-100 text-emerald-800 border-emerald-400",
  "Cancelled":          "bg-rose-100 text-rose-800 border-rose-300",
  // Legacy fallbacks
  "Development Server": "bg-sky-100 text-sky-800 border-sky-300",
  "Testing Server":     "bg-violet-100 text-violet-800 border-violet-300",
  "Closed":             "bg-zinc-200 text-zinc-700 border-zinc-400",
  "In-Live":            "bg-green-100 text-green-800 border-green-400",
  "V1 Delivered":       "bg-amber-100 text-amber-800 border-amber-300",
  "NA":                 "bg-zinc-100 text-zinc-700 border-zinc-300",
};

export const INVOICE_TONE = {
  draft:          "bg-zinc-100 text-zinc-700",
  sent:           "bg-blue-100 text-blue-800",
  partially_paid: "bg-amber-100 text-amber-800",
  paid:           "bg-emerald-100 text-emerald-800",
  overdue:        "bg-rose-100 text-rose-800",
};

export const CR_STATUS_TONE = {
  "Open":        "bg-sky-100 text-sky-800 border-sky-300",
  "In Progress": "bg-amber-100 text-amber-800 border-amber-300",
  "Done":        "bg-emerald-100 text-emerald-800 border-emerald-400",
  "Blocked":     "bg-rose-100 text-rose-800 border-rose-300",
  "Rejected":    "bg-zinc-200 text-zinc-700 border-zinc-400",
};

export const CR_SEVERITY_TONE = {
  "Critical": "bg-rose-100 text-rose-800 border-rose-400",
  "Major":    "bg-orange-100 text-orange-800 border-orange-400",
  "Minor":    "bg-blue-100 text-blue-800 border-blue-300",
};

export const INR   = (n) => "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 });
export const INR_P = (n) => "₹" + Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const fmtDate = (d) => {
  if (!d) return "—";
  try { return new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }); }
  catch { return d; }
};

export const fmtDateTime = (d) => {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleString("en-IN", {
      day: "2-digit", month: "short", year: "numeric",
      hour: "2-digit", minute: "2-digit", hour12: true,
    });
  } catch { return d; }
};
